/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { getProductsHistoryList } from "../../../apis/companies/products";
import { ControlTable } from "../../../components/Table";
import useForm from "../../../hooks/useForm";
import { getParams } from "../../../utils/params";
import { transformComma } from "../../../utils/validator/comma";
import ItemHistory from "./ItemHistory";

const HISTORY_TYPE = [
  { label: "품목추가", value: "addNew" },
  { label: "정보변경", value: "dataChange" },
  { label: "수량변경", value: "qtyChange" },
  { label: "품목삭제", value: "delete" },
]

const ItemHistories = (props) => {
  const [fields] = useState([
    { title: "변경일", key: "createdTime", type: 'date' },
    { title: "변경 전 품목명", key: "prevData.name" },
    { title: "변경 후 품목명", key: "data.name" },
    { title: "타입", key: "type", onTranslator: { list: HISTORY_TYPE } },
    {
      title: "수량", key: "type",
      onValue: (value, field, data) => {
        return (
          <>{value === 'addNew' ? transformComma(data.data.qty) : transformComma(data.qty)}</>
        )
      }
    },
    { title: "변경자", key: "employeeIdx", type: 'profile' },
  ]);
  const [open, setOpen] = useState(false)
  const [historyData, setHistoryData] = useState(null)

  const {
    form,
    setSubmit,
    handleSubmit,
    // Filter 추가 후 사용 handleOnChange,
    // Filter 추가 후 사용 filterSubmit,
    // LIST 용
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      order: [
        {
          idx: "desc"
        },
      ],
      page: 0,
      limit: 10
    },
  )

  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, []);

  const submit = (params) => {
    setIsLoading(true)
    getProductsHistoryList(getParams(params)).then((res) => {
      setTotal(res.data.count)
      setList(res.data.productsHistories.map((d) => ({
        ...d,
        data: JSON.parse(d.data),
        prevData: JSON.parse(d.prevData),
        employeeIdx: Number(d.employeeIdx)
      })))
    }).catch(() => { }).finally(() => {
      setIsLoading(false)
    })
  }

  const openDetail = (data, e) => {
    setOpen(true)
    setHistoryData(data)
  }

  return (
    <>
      <ControlTable
        fields={fields}
        list={list}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        submit={handleSubmit}
        onSelect={openDetail}
      />
      {open && historyData && (
        <ItemHistory open={open} setOpen={setOpen} data={historyData} setData={setHistoryData} />
      )}
    </>
  );
};

export default ItemHistories;
